import React, { useEffect, useState} from 'react';
import { Link, useParams} from 'react-router-dom';
import { db } from '../../firebase';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import './SingleAdminProduct.css';
import GoBackComponent from '../GoBackComponent';
import Loader from '../Loader';
import { useAuth } from '../../AuthContext';
import CarouselProduct from '../CarouselProduct';

const SingleProductPage = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState('');
  
  const { currentUser } = useAuth();
 
  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    const fetchProduct = async () => {
      const productDoc = doc(db, 'products', productId);
      const productSnapshot = await getDoc(productDoc);
      if (productSnapshot.exists()) {
        const fetchedProduct = { id: productSnapshot.id, ...productSnapshot.data() };
        setProduct(fetchedProduct);
        setSelectedImage(fetchedProduct.imageUrl);
        fetchRelatedProducts(fetchedProduct.categoryName); // Ensure this matches your Firestore structure
      } else {
        console.error('Product not found');
      }
    };

    const fetchRelatedProducts = async (category) => {
      try {
        const productsRef = collection(db, 'products');
        const q = query(productsRef, where('categoryName', '==', category)); // Ensure category field matches
        const querySnapshot = await getDocs(q);
        const related = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setRelatedProducts(related.filter(item => item.id !== productId).slice(0, 6)); // Exclude current product
      } catch (error) {
        console.error('Error fetching related products:', error);
      }
    };

    fetchProduct();
  }, [productId]);

  if (!product) {
    return (
      <div>
        <Loader/>
      </div>
    );
  }

 

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  return (
    <div className="ssingle-product">
        <div className="about-hero" style={{backgroundImage:`url(${product.imageUrl})`}}>
        <div className="hero-overlay">
          <h1 className="hero-heading">{product.name}</h1>
          <p className="hero-subheading"></p>
          <br />
          <div className="back-link">
             <Link to="/">
              <span>Home</span>
            </Link>
            <span>/</span>
            <span>{product.name}</span>
         </div>
        </div>
      </div>
      <h2>{product.name}</h2>
      <div className='ssingle-product-box'>
      <p className='quantity'>MIN: {product.quantity} Unit(s)</p>
        <img
          src={selectedImage}
          alt={product.name}
          className="main-image"
          onClick={() => setSelectedImage(product.imageUrl)}
        />
        <div className="image-thumbnails">
          <img
            src={product.imageUrl}
            alt="Main"
            className="thumbnail"
            onClick={() => handleImageClick(product.imageUrl)}
          />
          {product.detailImages?.map((imgUrl, index) => (
            <img
              key={index}
              src={imgUrl}
              alt={`Detail ${index + 1}`}
              className="thumbnail"
              onClick={() => handleImageClick(imgUrl)}
            />
          ))}
        </div>
        <div className="cart-button">
       
        <a href="https://wa.me/2348023879629?text=Hi,%20I%20want%20to%20print" target="_blank" rel="noopener noreferrer"
         className='we-chat'>Chat to Order
       </a>
       <GoBackComponent />
     </div>
        <div className='ssingle-product-details'>
          <h3>{product.name}</h3>
          <p className='pricee'>Price: <br /><strong>₦ {product.price}.00 <span>/</span> {product.quantity}</strong></p>
          <h4>Descriptions:</h4>
          <p className='p-detail'>{product.description}</p>
          <h4>Features:</h4>
          <ul className="features-list">
            {product.features?.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
         
          <p className='rating'>Rating: {product.rating} / 5</p>
        </div>
      </div>

      {/* Related Products Section */}
      <div className="rrelate-products">
        <h3>Related Products</h3>
        <div className="rrelate-products-grid">
          {relatedProducts.map((relatedProduct) => (
            <Link to={`/product/${relatedProduct.id}`}>
            <div key={relatedProduct.id} className="rrelate-product-item">
                <img src={relatedProduct.imageUrl} alt={relatedProduct.name} />
                <p>{relatedProduct.name}</p> <br />
                <p className='pricee'>₦{relatedProduct.price}.00 / {relatedProduct.quantity}</p>
            </div>
            </Link>
          ))}
        </div>
      </div>
      <h2>You may also like this</h2>
      <CarouselProduct/>
    </div>
  );
};

export default SingleProductPage;
